import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Divider, Tab } from '@mui/material'
import React, { useEffect, useState } from 'react'

import BlankCard from 'src/components/era-package/shared/BlankCard'
import { tabs } from './tabs'

export const ToolsView = () => {
  const [activeTab, setActiveTab] = useState(tabs[0].label)

  useEffect(() => {
    document.title = 'Tools'
  }, [])

  return <BlankCard sx={{ pt: 1 }}>
    <TabContext value={activeTab}>
      <TabList aria-label='tools tabs'
        onChange={(e, val) => setActiveTab(val)}
        sx={{ mx: 2 }}
      >
        {tabs.map(({ label }) => <Tab key={label}
          value={label} title={`Switch to ${label} tab`}
          label={label}
        />)}
      </TabList>
      <Divider />
      {tabs.map(({ label, component }) => (
        <TabPanel key={`${label}-tab`} value={label}
          sx={{ p: 3 }}
        >
          {component}
        </TabPanel>
      ))}
    </TabContext>
  </BlankCard>
}
